import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, TextField } from '@mui/material';
import { currentProblemActions } from '../../../../store/MedicalRecord/currentProblem';
import { CurrentProblemForm } from '../../../../types/types';
import { RootState } from '../../../../store';

interface Props {
  data?: CurrentProblemForm;
  viewMode: boolean;
}

const CurrentProblem = ({ data, viewMode }: Props) => {
  const dispatch = useDispatch();
  let currentProblem = useSelector((state: RootState) => state.currentProblem);

  if (viewMode && data != null) {
    currentProblem = data;
  }

  const setCurrentProblem = (event: React.ChangeEvent<HTMLInputElement>) => {
    const localData = event.target.value.trim();
    dispatch(currentProblemActions.setCurrentProblem(localData));
  };

  return (
    <Box>
      <h4>Problema actual</h4>
      <TextField
        id='currentProblem'
        label='Descripción completa del Problema'
        value={currentProblem.currentProblem}
        onChange={setCurrentProblem}
        multiline
        rows={18}
        fullWidth
        disabled={viewMode}
      />
    </Box>
  );
};

export default CurrentProblem;
